var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home"},[_c('div',{staticClass:"charts_wrap"},[_c('div',{staticClass:"user_wrap"},[_c('div',{staticClass:"charts_title"},[_vm._v("最近一年用户注册数据统计")]),_c('div',{staticClass:"user_echarts"})])])])
}]

export { render, staticRenderFns }